/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1BannerIdQueryResponse,
  GetApiV1BannerIdPathParams,
  GetApiV1BannerId401,
  GetApiV1BannerId404,
  GetApiV1BannerId500,
} from "../../types/bannerRegistroController/GetApiV1BannerId.ts";

function getGetApiV1BannerIdUrl(id: GetApiV1BannerIdPathParams["id"]) {
  const res = { method: "GET", url: `/api/v1/banner/${id}` as const };
  return res;
}

/**
 * @description Retorna os dados completos de um banner pelo seu identificador. **(Requer Authorization para autenticação)**
 * @summary Obter banner por ID (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:id}
 */
export async function getApiV1BannerId(
  id: GetApiV1BannerIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1BannerIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1BannerId401 | GetApiV1BannerId404 | GetApiV1BannerId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1BannerIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
